<template>
  <div style="display: none;">
    <slot v-if="ready"></slot>
  </div>
</template>

<script>
// import firebase from 'firebase'
import L from 'leaflet'
import propsBinder from 'vue2-leaflet/src/utils/propsBinder.js'
import findRealParent from 'vue2-leaflet/src/utils/findRealParent.js'
import 'leaflet-minimap'  // eslint-disable-line
import 'leaflet-minimap/dist/Control.MiniMap.min.css'

const props = {
  areas: {
    type: Array,
    custom: true
  },
  posts: {
    type: Array,
    custom: true
  }
}

export default {
  name: 'LMiniMap',
  props: props,
  data () {
    return {
      ready: false,
      circle: {
        center: L.latLng(307.5, 380.5),
        radius: 10,
        options: {
          color: 'blue',
          fillColor: '#bbf',
          fillOpacity: 0.5
        }
      },
      dots: null
    }
  },
  mounted () {
    this.initMiniMap()
  },
  beforeDestroy () {
    this.parentContainer.mapObject.removeControl(this.mapObject)
  },
  methods: {
    initMiniMap () {
      this.parentContainer = findRealParent(this.$parent)
      var mapWidth = this.parentContainer.mapObject._size.x / 5
      var mapHeight = (this.parentContainer.mapObject._size.y / this.parentContainer.mapObject._size.x) * mapWidth
      this.mapObject = new L.Control.MiniMap(this.getLayers(), {
        // zoomLevelFixed: 0,
        zoomLevelOffset: -15,
        toggleDisplay: false,
        autoToggleDisplay: true,
        aimingRectOptions: {color: '#333', weight: 0, clickable: false},
        shadowRectOptions: {color: '#F2C247', weight: 1, opacity: 0, fillOpacity: 0},
        width: mapWidth,
        height: mapHeight,
        mapOptions: {
          crs: L.CRS.Simple
        }
      })
      L.DomEvent.on(this.mapObject, this.$listeners)
      propsBinder(this, this.mapObject, props)
      this.ready = true
      this.mapObject.addTo(this.parentContainer.mapObject)
    },
    getLayers () {
      var layers = []
      layers.push(L.imageOverlay(require('@/assets/mapBg.svg'), [[0, 0], [1000, 1000]]))
      this.posts.forEach(post => {
        layers.push(new L.Circle(L.latLng(post.position.lat, post.position.lng), {radius: 1.5, stroke: false, fillOpacity: 1, color: '#334274'}))
      })
      this.areas.forEach(area => {
        var bound0 = L.latLng(area.latLng.lat - area.size.height / 2, area.latLng.lng + area.size.width / 2)
        var bound1 = L.latLng(area.latLng.lat + area.size.height / 2, area.latLng.lng - area.size.width / 2)
        var bounds = [bound0, bound1]
        if (area.internal) {
          layers.push(L.imageOverlay(require('@/assets/naturalCircle' + area.circle + 'h.svg'), bounds, {opacity: 0.07}))
        } else {
          layers.push(L.imageOverlay(require('@/assets/naturalCircle' + area.circle + '.svg'), bounds, {opacity: 0.07}))
        }
      })
      var layer = new L.LayerGroup(layers)
      return layer
    },
    setAreas (newVal, oldVal) {
      // console.log('set areas')
      this.mapObject.changeLayer(this.getLayers())
    },
    setPosts (newVal, oldVal) {
      // console.log('set Posts')
      this.mapObject.changeLayer(this.getLayers())
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LMiniMap.vue